window.addEventListener('load', (event) => {

  let product = {}

  try {
    product = JSON.parse(document.getElementById('ProductJson').innerHTML);
  } catch {

  }
  (function(){
    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('variant')) {
        let param = searchParams.get('variant');
        let currentObject = product.variants.find(item => item.id == param);
        let currentId = "";
        if (currentObject != null) {
        currentId = currentObject.option1
        }
        if (currentId != "") {
        $('.thumbnail-list__item').removeClass('hide-imgs');
        $('.thumbnail-list__item').each(function () {
            let dataValue = $(this).data("varinet-id");
            if (currentId != dataValue) {
            $(this).addClass("hide-imgs");
            }
            if (dataValue.indexOf(".mp4") !== -1) {
            $(this).removeClass("hide-imgs");
            }

        })
        }

    }

    })();  
});